import { useLocation } from "react-router-dom"

const InitErrorPageLogic = () => {
    const location = useLocation()
    const {status, message} = location.state ?? {status: null, message: null}

    return {status, message}        
}

export default InitErrorPageLogic